import React from 'react'
import './normal-input.scss'

function TextAreaInput({
    label = 'Label',
    name = 'name',
    id,
    type,
    onChangeFun,
    value = '',
    colorCode,
    placeholder,
    isRequired = true,
    min = null,
    max = null,
    step
}) {
    return (
        <div className='input-model-div normal-input'>
            <div>
                <textarea
                    name={name}
                    id={id || name}
                    placeholder={placeholder}
                    required={isRequired}
                    onChange={onChangeFun}
                    min={min}
                    max={max}
                    step={step}
                >
                    {value}
                </textarea>

                <label htmlFor={id || name}>{label}</label>
            </div>
        </div>
    )
}

export default TextAreaInput